import { HrSimulationOfficialGrade } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/helpers/types';

type FlattenedGradeDetail = {
    grade: string;
    filiere: string;
    echelon: string;
    majoredIndex: string;
    rawIndex: string;
    duration: number;
    rawSalary: number;
    increasePercentage: number;
};

export function flattenHrSimulationOfficialGrade(
    data: HrSimulationOfficialGrade[],
): FlattenedGradeDetail[] {
    const flattenedData: FlattenedGradeDetail[] = [];

    data.forEach((gradeData) => {
        Object.entries(gradeData.gridEchelons).forEach(
            ([key, echelonDetails]) => {
                const flattenedEntry: FlattenedGradeDetail = {
                    grade: gradeData.grade,
                    filiere: gradeData.filiere,
                    echelon: key,
                    ...echelonDetails,
                };
                flattenedData.push(flattenedEntry);
            },
        );
    });

    flattenedData.sort((a, b) => {
        if (a.filiere !== b.filiere) {
            return a.filiere.localeCompare(b.filiere);
        }
        if (a.grade !== b.grade) {
            return a.grade.localeCompare(b.grade);
        }
        return parseFloat(a.echelon) - parseFloat(b.echelon);
    });

    return flattenedData;
}
